const Data = [
    {
        name: "Swastik Sambhav",
        position: "TechOps Head",
        imageUrl: "/assets/images/members/SwastikSambhav.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
    
]

export default Data;